// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store' // 导入vuex文件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.css'
import 'babel-polyfill'

import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

Vue.use(ElementUI)

// Vue.prototype.$imgBaseUrl = 'http://10.77.77.226:8080'//张佩
Vue.prototype.$imgBaseUrl = 'https://xyqyfw.com'

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store, //挂载store，this将自动生成$store属性
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js